import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { signOut } from '../../store/actions';
import TopNavBar from '../../components/TopNavBar';
import withGlobals from '../../withGlobals';

class LayoutWithNav extends Component {
  render() {
    return (
      <div>
        {!this.props.isEmbed && <TopNavBar signOut={this.props.signOut} />}
        {React.cloneElement(this.props.children, this.props)}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isEmbed: state.isEmbed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => {
      dispatch(signOut());
      dispatch(push('/'));
    },
    navTo: path => dispatch(push(path)),
  };
};

const enhance = compose(
  withRouter,
  withGlobals(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(LayoutWithNav);
